/* Fishe: "N / total" photo counter for the phone product gallery (rendered by snippets/product-gallery.liquid). */
(() => {
  if (customElements.get('fishe-gallery-count')) return;

  class FisheGalleryCount extends HTMLElement {
    connectedCallback() {
      this.carousel = document.getElementById(this.getAttribute('aria-controls'));
      if (!this.carousel) return;

      this.queueUpdate = this.queueUpdate.bind(this);
      this.carousel.addEventListener('scroll', this.queueUpdate, { passive: true });
      this.carousel.addEventListener('carousel:change', this.queueUpdate);
      this.carousel.addEventListener('carousel:filter', this.queueUpdate);

      // Variant changes hide or show photos through the hidden attribute.
      this.mutationObserver = new MutationObserver(this.queueUpdate);
      this.mutationObserver.observe(this.carousel, { subtree: true, attributes: true, attributeFilter: ['hidden'] });

      this.resizeObserver = new ResizeObserver(this.queueUpdate);
      this.resizeObserver.observe(this.carousel);

      this.queueUpdate();
    }

    disconnectedCallback() {
      if (!this.carousel) return;
      this.carousel.removeEventListener('scroll', this.queueUpdate);
      this.carousel.removeEventListener('carousel:change', this.queueUpdate);
      this.carousel.removeEventListener('carousel:filter', this.queueUpdate);
      this.mutationObserver?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }

    queueUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        this.update();
      });
    }

    update() {
      const cells = Array.from(this.carousel.children).filter(
        (cell) => cell.classList.contains('product-gallery__media') && !cell.hidden
      );
      const total = cells.length;

      this.hidden = total < 2;
      if (total < 2) return;

      // The current photo is the one whose leading edge sits closest to the carousel's leading edge.
      const rtl = getComputedStyle(this.carousel).direction === 'rtl';
      const carouselRect = this.carousel.getBoundingClientRect();
      const start = rtl ? carouselRect.right : carouselRect.left;
      let current = 0;
      let closest = Infinity;

      cells.forEach((cell, index) => {
        const rect = cell.getBoundingClientRect();
        const distance = Math.abs((rtl ? rect.right : rect.left) - start);
        if (distance < closest) {
          closest = distance;
          current = index;
        }
      });

      const text = `${current + 1} / ${total}`;
      if (this.textContent !== text) this.textContent = text;
    }
  }

  customElements.define('fishe-gallery-count', FisheGalleryCount);
})();
